"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconComponentWrapper = exports.LineWrapper = exports.IconButton = exports.PaybackButtonText = exports.ButtonText = exports.ButtonContainer = exports.PaybackButton = exports.Button = exports.ButtonInterface = exports.Wrapper = void 0;
const native_1 = __importStar(require("styled-components/native"));
exports.Wrapper = native_1.default.View `
  margin: 20px;
  width: 40%;
`;
const setMargin = (loadingText, loading) => {
    return (loadingText &&
        loading &&
        native_1.css `
      margin-left: 20px;
    `);
};
exports.ButtonInterface = native_1.default.TouchableOpacity `
  min-height: ${({ theme, size }) => theme.bpCore.button.size[size].height};
  border: ${({ theme, type }) => theme.bpCore.button.type[type].border};
  border-radius: ${({ theme, size }) => theme.bpCore.button.size[size].borderRadius};
  justify-content: center;
  align-items: center;
  border-color: ${({ theme, type, inverted }) => inverted
    ? theme.bpCore.button.type[type].inverted.borderColor
    : theme.bpCore.button.type[type].borderColor};
  background-color: ${({ theme, type, inverted }) => inverted
    ? theme.bpCore.button.type[type].inverted.backgroundColor
    : theme.bpCore.button.type[type].backgroundColor};
`;
exports.Button = native_1.default(exports.ButtonInterface) `
  padding-vertical: ${({ theme, size }) => theme.bpCore.button.size[size].paddingVertical};
  padding-horizontal: ${({ theme, size, type }) => theme.bpCore.button.type[type].horizontalPadding
    ? theme.bpCore.button.size[size].paddingHorizontal
    : 0};
  ${({ type, disabled, theme }) => disabled &&
    native_1.css `
      border-color: ${theme.bpCore.button.type[type].disabled.borderColor};
      background-color: ${theme.bpCore.button.type[type].disabled
        .backgroundColor};
    `}
`;
exports.PaybackButton = native_1.default(exports.Button) `
  border-color: ${({ type, inverted, theme }) => {
    return inverted
        ? theme.bpCore.paybackButton.type[type].inverted.borderColor
        : theme.bpCore.paybackButton.type[type].borderColor;
}};

  background-color: ${({ theme, type, inverted, disabled }) => {
    if (inverted) {
        return theme.bpCore.paybackButton.type[type].inverted.backgroundColor;
    }
    if (!inverted && disabled) {
        return theme.bpCore.paybackButton.type[type].disabled.backgroundColor;
    }
    return theme.bpCore.paybackButton.type[type].backgroundColor;
}};
`;
exports.ButtonContainer = native_1.default.View `
  flex-direction: row;
  align-items: center;
`;
exports.ButtonText = native_1.default.Text `
  color: ${({ theme, type, inverted }) => inverted
    ? theme.bpCore.button.type[type].inverted.color
    : theme.bpCore.button.type[type].color};
  font-family: ${({ theme, type }) => theme.bpCore.button.type[type].fontFamily};
  letter-spacing: ${({ theme, size }) => theme.bpCore.button.size[size].letterSpacing};
  font-size: ${({ theme, size }) => theme.bpCore.button.size[size].fontSize};
  text-align: center;
  ${({ type, disabled, theme }) => disabled &&
    native_1.css `
      color: ${theme.bpCore.button.type[type].disabled.color};
    `}
  ${({ loadingText, loading }) => setMargin(loadingText, loading)}
`;
exports.PaybackButtonText = native_1.default(exports.ButtonText) `
  color: ${({ type, inverted, theme }) => {
    return inverted
        ? theme.bpCore.paybackButton.type[type].inverted.color
        : theme.bpCore.paybackButton.type[type].color;
}};
  ${({ loadingText, loading }) => setMargin(loadingText, loading)}
`;
exports.IconButton = native_1.default(exports.ButtonInterface) `
  width: ${({ theme, size }) => theme.bpCore.button.size[size].height};
`;
exports.LineWrapper = native_1.default.View `
  padding-top: 4px;
`;
exports.IconComponentWrapper = native_1.default.View `
  margin-right: 16px;
`;
